module.exports = __webpack_public_path__ + "images/backgrounds/city/full.80155d63e702f4b6abab.jpg";